export default {
    menu: ({ menu }) => menu,
    menuFlat: ({ menuFlat }) => menuFlat
};
